module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "klickbox-step-text-edit"
  }, [(_vm.step.text_size === 'long') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.placeholderText),
      expression: "placeholderText"
    }],
    staticClass: "klickbox-step-input-edit",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.placeholderText)
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateTextPlaceholder({
          placeholderText: $event.target.value,
          id: _vm.step.id
        })
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.placeholderText = $event.target.value
      }
    }
  }) : _c('input', {
    staticClass: "klickbox-step-input-edit",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.placeholderText
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateTextPlaceholder({
          placeholderText: $event.target.value,
          id: _vm.step.id
        })
      }
    }
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-49b0f544!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/kind/Text.vue
 ** module id = 817
 ** module chunks = 1
 **/